// insert player function
$.fn.insertPlayer = function () {
    let $video = $(this),
        $placeholder = $video.find('.fancy-video__placeholder'),
        $playButton = $video.find('.fancy-video__play'),
        $btn = $video.closest('.video-block').find('.btn--play-video'),
        vidURL = $video.data('video-url'),
        player;

    if (typeof vidURL === "undefined" || vidURL === '') {
        return false;
    }

    if ($video.attr('class').indexOf('upload') > -1) {
        player = '<video class="fancy-video__player" controls autoplay playsinline><source type="video/mp4" src="' + vidURL + '"></video>';
    }

    if ($video.attr('class').indexOf('youtube') > -1) {
        player = '<iframe class="fancy-video__player" src="' + vidURL + '?autoplay=1&autohide=1&showinfo=0&controls=1&border=0&modestbranding=0&wmode=opaque&enablejsapi=1&version=3hl=nl_NL&rel=0&hd=1&iv_load_policy=3&mute=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
    }

    if (!$video.hasClass('fancy-video--playing')) {
        $video.addClass('fancy-video--playing');
    }

    if ($btn.length > 0) {
        $btn.prop('disabled', true).addClass('btn--disabled');
    }

    $('.btn--play-video[data-video-id="'+ $video.data('video-id') +'"]').prop('disabled', true);

    $placeholder.hide();
    $playButton.hide();
    $video.append(player);
};


$('.fancy-video__placeholder').on('click', function () {
    $(this).siblings('.fancy-video__play').trigger('click');
});


$('.fancy-video__play').on('click', function () {
    let $video = $(this).closest('.fancy-video');

    if ($video.length > 0) {
        $video.insertPlayer();
    }
});

$('.btn--play-video').on('click', function () {
    let $video = $('.fancy-video[data-video-id="'+ $(this).data('video-id') +'"]');

    if ($video.length > 0 && !$video.hasClass('fancy-video--playing')) {
        $video.insertPlayer();
    }
});
